import React from "react";
import assets from "../../../shared/constants/assetVariables";
const doubleMaterialAssessmentFeature = [
  {
    id: "1",
    icon: assets.icons.dma1,
    heading: "Stakeholder Group Creation",
    description:
      "Define and categorize stakeholder groups for targeted engagement.",
  },
  {
    id: "2",
    icon: assets.icons.dma2,
    heading: "Comprehensive Materiality Assessment",
    description:
      "Integrated methodology to assess both financial materiality (impact on business performance) and impact materiality (business impact on society and the environment).",
  },
  {
    id: "3",
    icon: assets.icons.dma3,
    heading: "Pre-Built & Customizable CSRD Topics",
    description:
      "Built on CSRD-defined sustainability topics with the flexibility to incorporate sector-specific issues from other global frameworks (SASB, TCFD, etc.).",
  },
  {
    id: "4",
    icon: assets.icons.dma4,
    heading: "AI-Powered IRO Generation",
    description:
      "Automatically generate Impact, Risk, and Opportunity (IRO), ensuring alignment with CSRD and ESRS requirements.",
  },
  {
    id: "5",
    icon: assets.icons.dma5,
    heading: "Dynamic Materiality Matrix",
    description:
      "Auto-generated, interactive materiality matrix visualizing issue prioritization based on stakeholder input and business relevance.",
  },
  {
    id: "6",
    icon: assets.icons.dma6,
    heading: "Automated Report Generation",
    description:
      "Generates structured, audit-ready Double Materiality Reports aligned with ESRS guidelines.",
  },
];
function Section_3() {
  return (
    <section className="csrd-landing-page-section-3-container">
      <div className="csrd-landing-page-section-3-header-container">
        <div
          className="csrd-landing-page-section-3-header"
          data-aos="fade-down"
          // data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <span className="text-1">Double Materiality</span>{" "}
          <span className="text-2">Assessment</span>
        </div>
        <div
          className="csrd-landing-page-section-3-description"
          data-aos="fade-up"
          // data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true"
        >
          Double materiality analysis allows users to identify and prioritize
          sustainability issues that impact both their business and
          stakeholders, ensuring full CSRD compliance.
        </div>
      </div>
      <div
        className="key-feature-heading"
        data-aos="zoom-in"
        data-aos-duration="700"
        data-aos-once="true"
      >
        Key Features
      </div>
      <div className="key-feature-content-container">
        <div className="key-feature-inner-content-container">
          <div className="key-feature-left-container">
            <div
              className="dash-circle-1"
              data-aos="zoom-in"
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div
                className="dash-circle-2"
                data-aos="zoom-in"
                data-aos-duration="700"
                data-aos-once="true"
              ></div>
            </div>
            <div
              className="dma-stakeholder-imag-container"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
            >
              <img
                src={assets.images.dma_stakeholder}
                alt="dma-stakeholder"
                loading="lazy"
                className="dma-stakeholder"
              />
            </div>
          </div>
          <div
            className="key-feature-right-container"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="700"
            data-aos-once="true"
          >
            {doubleMaterialAssessmentFeature?.map((ele) => {
              return (
                <div className="key-feature-card-container" key={ele?.id}>
                  <div className="dma-icon">
                    <img src={ele?.icon} alt="dm1-icon" />
                  </div>
                  <div className="feature-header-description-container">
                    <div className="feature-header">{ele?.heading}</div>
                    <div className="feature-description">
                      {ele?.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section_3;
